import styled from '@emotion/styled';
import type { ChipProps } from '@mui/material';
import { Chip as MuiChip } from '@mui/material';

const StyledChip = styled(MuiChip)`
  font-size: 14px;
  padding: 0 ${({ theme }) => theme.spacing(0.5)} 0
    ${({ theme }) => theme.spacing(0.75)};
  cursor: pointer;

  > svg {
    margin-left: 0 !important;
    margin-right: -8px !important;
  }

  > span {
    padding-right: 6px;
    padding-left: 12px;
  }
`;

const Chip = ({ ...props }: ChipProps) => {
  return <StyledChip {...props} />;
};

export default Chip;
